import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M11.647 3.651a.5.5 0 0 1 .707-.01l8.065 7.84a.5.5 0 0 1 0 .717l-8.065 7.84a.5.5 0 1 1-.697-.716l7.182-6.982H3a.5.5 0 0 1 0-1h15.84l-7.183-6.981a.5.5 0 0 1-.01-.708Z",
      fill: "#17191C"
    }, null, -1)
  ])))
}
export default { render };